import {Address} from '@/profile-creation-wizard/types';

export default class LocationValidation {
    isValid(address?: Address): boolean {
        if (!address) {
            return false;
        }

        if (!address.countryCode || !address.city || !address.lat || !address.lon) {
            return false;
        }

        if (!address.formattedAddress || address.formattedAddress.length > 100) {
            return false;
        }

        return true;
    }

    isValidCountry(blockedCountries: string[], address?: Address): boolean {
        if (!address || !address.countryCode) {
            return false;
        }

        return !blockedCountries.includes(address.countryCode!.toUpperCase());
    }
}
